import React from 'react';

const MainApplicationContext = React.createContext({});

export default MainApplicationContext;
